<template>
  <div class="container">
    <img class="logo" src="../../assets/image/logo.png"></img>
    <img class="line" src="../../assets/image/login/login_line.png"/>
    <div class="box-login" id="loginBox">
      <div class="box-title">登陆</div>
      <el-form
      ref="form"
      :model="form"
      :rules='rules'
      style="width: 86%;"
      label-width="100px">
        <el-form-item
        label="账号"
        prop="username"
        >
          <el-input id="username" v-model="form.username" prefix-icon="iconfont el-icon-user-solid">
          </el-input>
        </el-form-item>
        <el-form-item
        label="密  码"
        prop="password">
          <el-input id="password" v-model="form.password" prefix-icon="iconfont el-icon-s-order">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input id="phone" v-model="form.phone" prefix-icon="iconfont el-icon-phone" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="手机验证码" prop="code"  class="checkCode">
            <el-input
              id="code"
              v-model="form.code"
              prefix-icon="iconfont el-icon-s-claim"
              label="验证码"
              style="width: 100%;"
              oninput="value=value.replace(/[^\d]/g,'')">
            </el-input>
          <el-button
            size="mini"
            style="margin-top: -50px;margin-right: 5px;float: right;position: relative;"
            @click.stop="getCode"
            v-if="show"
            >获取验证码</el-button>
          <el-button
          size="mini"
          type="primary"
          style="margin-top: -50px;margin-right: 5px;float: right;position: relative;"
          v-if="!show"
          disabled
          >{{ count }}秒后重发</el-button>
        </el-form-item>
        <el-form-item style="margin-top: 40px;">
          <el-button
          type="primary"
          @click="submitForm('form')"
          size="medium"
          style="width: 300px;height: 60px;font: 18px normal solid;background-color:#083171;border-radius: 30px;">
          登陆</el-button>
        </el-form-item>
      </el-form>
      <!-- <div class="bottom">没有账号？<span style="color: #00FFFF" @click="toRegisterBox()">点此注册</span></div> -->
    </div>
    <div class="app-footer">
            <!-- <img src="../../assets/image/logo1.png" alt="" srcset=""> -->
            <!-- <p style="font-size: 28px;margin-top: 22px;font-weight: 800;">数据管理软件</p> -->
            <!-- <p style="margin-top: 3px;">版本：<span>{{Ver}}</span></p> -->
            <p style="margin-top: 60px;">
              <span>Copyright  ©  上海导向医疗系统有限公司  All Rights Reserved</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <el-link :href="link" target="_blank">沪ICP备19046950号-1</el-link>
            </p>
            <p style="margin-top: 20px;display: flex;flex-direction: row;align-items: center;justify-content: center;">
              <el-link :href="webSearch"><img src="../../assets/image/beian.png" alt=""></el-link>
              <el-link :href="webSearch"style="margin-left: 5px;">沪公网安备 31011502016064号</el-link>
            </p>
    </div>

  </div>
</template>

<script>
  // import store from '../../store/index.js'
  import * as auth from '../../utils/auth.js'

  export default {
    data() {
      return {
        link:'https://beian.miit.gov.cn',
        webSearch:"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016064",
        form: {
          username:'',
          password: '',
          phone: '',
          code:''
        },
        rules:{
          username:[{required: true, message: '请输入账号',trigger:'blur'}],
          password:[{required: true, message: '请输入密码',trigger:'blur'}],
          phone: [{required: true,message:'请输入手机号',trigger:'blur',},
                  // {pattern:/^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,message:'请输入正确的手机号'},
                  {min: 11,max:11,message:'请输入11位手机号'}],
          code: [{required: true, message: '请输入验证码',trigger:'blur'},
                  {min: 6,max:6,message:'请输入6位验证码'}]
        },
        show: true,
        count: "",
        timer: null,
      }
    },
    methods: {
      // 图片验证码
      // resetImgCode(){
      //   this.imgUrl = 'http://localhost:8888/verifyCode?time='+new Date();
      // },
      //验证码 倒计时
      countDown() {
        let TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      isMobile:function(value){
        return /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
      },
      //验证码
      getCode() {
        if (!this.form.phone) {
          this.$message('请输入手机号');
          return;
        }

        if (this.form.phone.length !== 11) {
          this.$message('请输入11位手机号');
          return;
        }

        if(!this.isMobile(this.form.phone)){
          this.$message('手机号码格式错误');
          return;
        }

        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/auth/sms';
        const data = {
          "phone":this.form.phone,
          "type":1
        }

        this.$http({
          method:'POST',
          url:url,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'验证码已发送',
                type:'success'
              })
              this.countDown();
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.sign()
          } else {
            return false;
          }
        });
      },
      //登录
      sign(formName) {
        const url = '/auth/login';
        const data = {
          "username":this.form.username,
          "password":this.form.password,
          "phone":this.form.phone,
          "authCode":this.form.code
        }

        this.$http({
          method:'POST',
          url:url,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功

          var obj = res.data;

            if(obj.code == 0){
              if(obj.data.token){

                this.$message({
                  type:'success',
                  message:'登陆成功'
                })

                //存储
                this.$store.commit('setToken',obj.data.token)
                this.$store.commit('setPermission',obj.data.permissions);

                this.$router.replace('/index');
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  padding-bottom: 30px;
  margin: 0 auto;

  height:auto !important;
  // height:100%;
  // background: url('../../assets/image/home/home_back.jpg') no-repeat;
  // -moz-background-size: 100% 100%;
  // background-size: 100% 100%;

    .logo{
      width: 34%;
      margin: 0 auto;
      margin-top: 35px;
      margin-bottom: 4px;
    }

    .line{
      width: 34%;
      margin: 0 auto;
      margin-bottom: 60px;
    }


    .box-login{
    	width: 600px;//690
    	height: 590px;
    	border-radius: 5px;
    	margin: 0 auto;
    	background-image: url('../../assets/image/login/login_box.png');
      -moz-background-size:100% 100%;
      background-size:100% 100%;

      display: flex;
      flex-direction: column;
      align-items: center;

      .box-title{
        font-size: 22px;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 45px;
        margin-bottom: 50px;
      }

      .checkCode::v-deep .el-form-item__content{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
      }


      .bottom{
        color: #FFFFFF;
        // background-color: brown;
        // margin-top: 30px;
        // z-index: 999;

        span:hover{
          cursor: pointer;
        }
      }

    }

    .app-footer {
      min-width: 600px;
      width: 100%;
      // height: 100%;
      color: #fff;
      // margin-top: $header-height;

      .el-link{
        color: #fff;
      }
    }

    .el-form-item__label{
      color: #FFFFFF;
      font-size: 18px;
      font-weight: 400;
    }

    .el-input__inner{
      float: left;
      background-color: RGBA(17, 58, 113, 0.5);
      border: 2px solid #1D4BB6;
      border-radius: 6px;
      box-shadow: 2px 2px 0 0 rgba(0,0,0,0.2);
      caret-color: rgba(0,255,255,0.8);
      color: #FFFFFF;
      font-size: 18px;
      font-weight: 400;
    }

    .el-form-item{

    }

    .el-input__inner::hover{
      border-color: rgb(0,255,255);
    }

    .el-input__inner:focus{
      border-color: aqua;
    }

    //表单验证错误提示偏移
    .el-form-item__error{
      // margin-top: -14px;
    }

    /deep/.sel .el-select__caret{
      //清除默认的select选择框样式
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      padding-right: 14px;//箭头位置
      // 自定义图片
      // background: ;
      // background-size: ;
      // margin-top: 40px;
    }

    /deep/.sel .el-icon-arrow-up:before{
      content: '';
    }

    .el-select-dropdown el-popper{
      position: absolute!important;
      top: 140px !important;
      left: 30px !important;
    }

  }

</style>



// WEBPACK FOOTER //
// src/view/login/login.vue